interface CustomTextAreaProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  id?: string;
  required?: boolean;
  testId?: string;
  disabled?: boolean;
}

export function CustomTextArea({ value, onChange, placeholder, className, id, required, testId, disabled }: CustomTextAreaProps) {
  return (
    <textarea
      id={id}
      placeholder={placeholder || ""}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      className={`w-full !border-0 ring-1 ring-inset ring-gray-300 rounded-[6px] px-4 py-3 leading-6 text-[16px] min-h-[135px] bg-white resize-none focus:ring-black disabled:opacity-60 ${className || ''}`}
      style={{ fontFamily: "TT Commons Pro" }}
      aria-required={required}
      data-testid={testId}
    />
  );
}
